<div class="d-flex flex-column justify-content-center align-items-center min-vh-100 p-4">
  <div class="d-flex align-items-center">
    <fa-icon class="text-warning me-4" size="4x" icon="triangle-exclamation"></fa-icon>
    <h3 class="title info-container text-center fw-bold">
      This link is no longer valid. To access the latest version of ApplyME click below or type in your browser:
      <a href="https://www.melcoapplyme.com">www.melcoapplyme.com</a>
    </h3>
  </div>
  <div class="mt-4 home-link">
    <apm-button routerLink="/">Go to home page</apm-button>
  </div>
</div>
